import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-4 py-3 h-full flex flex-col" }
const _hoisted_2 = { class: "mb-3 mr-4 flex items-center gap-2" }

import { computed } from "vue";
import { useHierarchyTags } from "shared/composables/hierarchyTags";
import { usePlanConfig } from "shared/composables/planner";
import { useShortenedProcessesWithTags } from "shared/composables/process";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useProjectDurationSettings } from "shared/composables/projectDurationSettings";
import { useTrackEvent } from "shared/composables/tracking";
import BaseWidget from "@/views/dashboard/componentsV2/BaseWidget.vue";
import DashboardDragHandle from "@/views/dashboard/componentsV2/DashboardDragHandle.vue";
import { normalWidgetWidth } from "@/views/dashboard/composables";
import ProjectProgressTable from "@/views/planner/components/ProjectProgressTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlannerWidget',
  props: {
    width: {},
    height: {}
  },
  emits: ["delete", "widgetRouteClicked", "trackInteraction"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const trackEvent = useTrackEvent();

const { planConfig, isLoading: isPlanConfigLoading } = usePlanConfig();
const { shortenedProcessesWithTags, isLoading: areShortenedProcessesWithTagsLoading } =
  useShortenedProcessesWithTags();
const { projectDurationSettings, isProjectDurationSettingsLoading } = useProjectDurationSettings();
const { hierarchyTags, isLoading: areHierarchyTagsLoading } = useHierarchyTags();

const isLoading = computed(
  () =>
    isPlanConfigLoading.value ||
    areShortenedProcessesWithTagsLoading.value ||
    isProjectDurationSettingsLoading.value ||
    areHierarchyTagsLoading.value,
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(BaseWidget, {
    isLoading: isLoading.value,
    onDelete: _cache[1] || (_cache[1] = ($event: any) => (emit('delete'))),
    onTrackInteraction: _cache[2] || (_cache[2] = ($event: any) => (emit('trackInteraction'))),
    onTrackZoomClicked: _cache[3] || (_cache[3] = ($event: any) => (_unref(trackEvent)('progress_detail_click', { origin: 'planner_widget' }))),
    hideDragHandle: "",
    showZoomIcon: true
  }, {
    zoomedView: _withCtx(() => [
      (_unref(planConfig) && _unref(shortenedProcessesWithTags) && _unref(projectDurationSettings))
        ? (_openBlock(), _createBlock(ProjectProgressTable, {
            key: 0,
            class: "h-full",
            planConfig: _unref(planConfig),
            processes: _unref(shortenedProcessesWithTags),
            projectDurationSettings: _unref(projectDurationSettings),
            hierarchyTags: _unref(hierarchyTags),
            showEvenWhenCompleted: true
          }, null, 8, ["planConfig", "processes", "projectDurationSettings", "hierarchyTags"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DashboardDragHandle, { class: "shrink-0" }),
          _createVNode(_component_RouterLink, {
            to: {
            name: 'PlannerV2',
            params: {
              customer_name: _unref(currentCustomerName),
              site_id: _unref(currentSiteId),
            },
          },
            class: _normalizeClass(["font-semibold text-gray-900 truncate hover:text-yellow-800 pr-4", _ctx.width > _unref(normalWidgetWidth) ? 'text-lg' : 'text-base']),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('widgetRouteClicked')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.project.planner_card.current_procedures")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ]),
        (_unref(planConfig) && _unref(shortenedProcessesWithTags) && _unref(projectDurationSettings))
          ? (_openBlock(), _createBlock(ProjectProgressTable, {
              key: 0,
              class: "flex-1 overflow-hidden",
              planConfig: _unref(planConfig),
              processes: _unref(shortenedProcessesWithTags),
              projectDurationSettings: _unref(projectDurationSettings),
              hierarchyTags: _unref(hierarchyTags),
              simplified: true,
              showOnlyActive: true,
              hideCheckIconWhenCompleted: _ctx.width < _unref(normalWidgetWidth)
            }, null, 8, ["planConfig", "processes", "projectDurationSettings", "hierarchyTags", "hideCheckIconWhenCompleted"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["isLoading"]))
}
}

})